export default __webpack_public_path__ + "static/media/mainbg2.339a7dbd.png";